import React from 'react';
import { Image } from 'react-bootstrap';
// import intro from 'product-foundry-site-intro-threejs';
import { default as initAnimation } from "pf-birds";
import parse from 'html-react-parser';
import api from '../../../api';

class Visual extends React.Component {

  constructor(props) {
    super(props);
    this.animRef = React.createRef();
    
    this.env = api.getEnv();
    this.state = {
      imagemapsvg: null,
      imageBlob: null
    }
  }

  componentDidMount = () => {
    this.animRef.current !== null && initAnimation(this.animRef.current, this.env.texts);
    const imagemap = this.props.imagemap;
    if (imagemap) {
      api.getResource(this.props.eId, imagemap, "presentation").then(res => {
        res.text().then(svg => {
          this.setState({ imagemapsvg: svg.substring(svg.indexOf("<svg"), svg.length) });
        })
      })
    } else if (!this.props.module) {
      api.getResource(this.props.eId, this.props.image, "presentation").then(res => {
        this.setState({ imageBlob: URL.createObjectURL(res.data) });
      });
    }
  }

  render() {
    const { image, title, clickLink, module, role, overlay, link, imagemap } = this.props;
    const classes = link ? "linked" : "";
    const isModule = !!module;
    const isImage = image && image.indexOf("resource:image") > -1;
    const bg = imagemap ? { backgroundImage: this.state.imageBlob } : {};
    return (
      <div className={`visual-container overlay has-bg-img ${classes}`} style={bg}>
        {isImage && <React.Fragment>
          {!imagemap && <Image src={this.state.imageBlob}
            fluid className={`visual card-img ${classes} ${role}`} link={link} onClick={() => !overlay && link && clickLink(link)} />}
          {imagemap && this.state.imagemapsvg && parse(this.state.imagemapsvg)}
          {overlay && <div className="card-img-overlay" onClick={() => clickLink(link)} >
            {title && <h1>{title}</h1>}
            {<h2 className="m-0">{overlay}</h2>}
          </div>}
        </React.Fragment>
        }
        {isModule && <div className="animRef" ref={this.animRef}></div>}
      </div>
    )
  }
}
export default Visual;